import { siteX } from "../interceptors/api";
const base = (kind) => (kind === "ap" ? "ap-categories" : "node-categories");
const getAll = (kind, query) => siteX.post(`${base(kind)}/get-all`, query);
const getById = (kind, id) => siteX.get(`${base(kind)}/${encodeURIComponent(id)}`);
const create = (kind, command) => siteX.post(`${base(kind)}/create`, command);
const update = (kind, command) => siteX.put(`${base(kind)}/update`, command);
const remove = (kind, id) => siteX.delete(`${base(kind)}/${encodeURIComponent(id)}`);
/** All categories of a kind (id + name) for selects and filters. */
const getOptions = (kind) => siteX.get(`${base(kind)}/options`);
export const categoriesApi = { getAll, getById, create, update, remove, getOptions };
